/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ApiIncrementalityControlRegionFromJSON(json) {
    return ApiIncrementalityControlRegionFromJSONTyped(json, false);
}
export function ApiIncrementalityControlRegionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'city': !exists(json, 'city') ? undefined : json['city'],
        'country': !exists(json, 'country') ? undefined : json['country'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'incrementalityTestId': !exists(json, 'incrementalityTestId') ? undefined : json['incrementalityTestId'],
        'lat': !exists(json, 'lat') ? undefined : json['lat'],
        'lon': !exists(json, 'lon') ? undefined : json['lon'],
    };
}
export function ApiIncrementalityControlRegionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'city': value.city,
        'country': value.country,
        'id': value.id,
        'incrementalityTestId': value.incrementalityTestId,
        'lat': value.lat,
        'lon': value.lon,
    };
}
